import standbyBoltIconSource from "bootstrap-icons/icons/lightning-charge-fill.svg?raw";

export const STANDBY_BOLT_ICON_SVG_SOURCE = standbyBoltIconSource;
